import React from "react";
import { Avatar, Col, Empty, List, Form, Row } from "antd";
import { useState } from "react";
import { useFormik } from "formik";
import moment from "moment";
import { TagOutlined } from '@ant-design/icons';
import { Button, Modal } from "@public/ui-toolkit";
import { useRef } from "react";
import * as Yup from "yup";
import ReactModal from "@public/ui-toolkit/src/ReactModal";

const CompanyNote = ({ getNotes, loading, id, onSubmitNote, targetDivRef }) => {

  const [open, setOpen] = useState(false);
  const desRef = useRef("");
  const titleRef = useRef("");
  const showModal = () => {
    setOpen(true);
  }
  const formik = useFormik({
    initialValues: {
      tittle: "",
    },
    validationSchema: Yup.object({
      tittle: Yup.string().required("Tittle is Required."),
    }),
    onSubmit: () => {
      onSubmitNotes();
      desRef.current.value = "";
      titleRef.current.value = "";
      formik.resetForm();
    },
  });
  const closeModal = () => {
    setOpen(false);
    form.resetFields();
  }
  const [form] = Form.useForm();

  const onSubmitNotes = () => {
    const obj = {
      title: titleRef?.current?.value,
      description: desRef?.current?.value,
      fundId: Number(id),
    }
    onSubmitNote(obj, closeModal)
  }

  return (
    <>
      <Row className="component mt-3"ref={targetDivRef}>
        <Col span={21} className="component-header"> <div className="Fund-FontSize" style={{ fontSize: "26px" }}>Allocator Notes</div></Col>
        <Col span={3} className="component-header" style={{ textAlign : 'end' }}>
          <Button
            btnName="Create Note"
            btnType="primary"
            type="submit"
            onClick={() => showModal()}
          />
        </Col>

        <Col span={24} className="component-header" style={{ padding: "10px",  height: getNotes?.length > 0 ? "400px" : "170px", overflowY: "scroll" }}>
          {getNotes?.length > 0 ? (
            <List
              itemLayout="vertical"
              size="large"
              dataSource={getNotes}
              renderItem={(item) => (
                <List.Item
                  key={item.title}
                >
                  <List.Item.Meta
                    avatar={<Avatar src={item?.user?.profileUrl} />}
                    title={item?.user?.fullName}
                    description={item.title}
                  />
                  {item.description}
                </List.Item>
              )}
            />
          ) : (
            <div>
              <Empty />
            </div>
          )}
        </Col>
        {open && (
          <ReactModal
            title="Create Note"
            open={open}
            onClose={closeModal}
          >
            <Row>
              <Col span={24}>
                <form onSubmit={formik.handleSubmit}>
                  <div className="modal-body pt-0">
                    <div className="mt-3">
                      <input
                        type="text"
                        placeholder="Title"
                        className="form-control bg-lightgrey2"
                        {...formik.getFieldProps("tittle")}
                        ref={titleRef}
                      />
                      {formik.touched.tittle && formik.errors.tittle ? (
                        <div className="form-error-message  pt-4">
                          {formik.errors.tittle}
                        </div>
                      ) : null}
                    </div>
                    <div className="mt-2">
                      <textarea
                        placeholder="Write..."
                        className="form-control bg-lightgrey2"
                        rows="5"
                        ref={desRef}
                      />
                      {formik.touched.description && formik.errors.description ? (
                        <div className="form-error-message  pt-4">
                          {formik.errors.description}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="justify-content-center align-items-center d-flex">
                    <Button
                      btnName="Save"
                      btnType="primary"
                      type="submit"
                      loading={loading}
                    />
                  </div>
                </form>
              </Col>
            </Row>
          </ReactModal>
        )}
      </Row>
    </>
  );
};

export default CompanyNote;
